export default {
  LIST_FETCHED: 'OWNERS_FETCHED',
  LIST_LOAD: 'OWNERS_LOAD',
  ITEM_DETAIL: 'OWNERS_DETAIL',
  BUTTON_LOAD: 'OWNERS_BUTTON_LOAD',
};
